"use client"

import { memo } from "react"
import { Play, Pause } from "lucide-react"

type Props = {
  show: boolean
  isCurrentPlaylist: boolean
  isPlaying: boolean
  onPlay: (e: React.MouseEvent<HTMLButtonElement>) => void
}

function PlaylistCardPlayButton({
  show,
  isCurrentPlaylist,
  isPlaying,
  onPlay,
}: Props) {
  const playing = isCurrentPlaylist && isPlaying

  return (
    <button
      type="button"
      onClick={(e) => { 
        e.preventDefault()
        e.stopPropagation()
        onPlay(e)
      }}
      aria-label={playing ? "Pause playlist" : "Play playlist"}
      className={`
        absolute
        bottom-0
        right-2
        z-[100]
            
        flex
        h-10
        w-10
        items-center
        justify-center
            
        rounded-full
        bg-white
        text-black
        shadow-2xl
            
        pointer-events-auto
            
        transition-all
        duration-300
            
        hover:scale-105
        active:scale-95
            
        ${
          show
            ? "opacity-100"
            : "opacity-0 group-hover:opacity-100"
        }
      `}
    >
      {playing ? (
        <Pause size={18} strokeWidth={2.5} />
      ) : (
        <Play
          size={18}
          strokeWidth={2.5}
          fill="currentColor"
        />
      )}
    </button>
  )
}

export default memo(PlaylistCardPlayButton)



/* "use client"

import { memo } from "react"
import { Play, Pause } from "lucide-react"

type Props = {
  show: boolean
  isPlaying: boolean
  onPlay: (e: React.MouseEvent<HTMLButtonElement>) => void
}

function PlaylistCardPlayButton({
  show,
  isPlaying,
  onPlay,
}: Props) {
  return (
    <button
      onClick={onPlay}
      aria-label="Play playlist"
      className={`
        absolute
        bottom-1
        right-1
        z-30 flex
        h-10 w-10
        items-center
        justify-center
        rounded-full
        bg-white
        text-black
        shadow-2xl

        transition-all
        duration-300
        hover:scale-105
        active:scale-95

        ${
          show
            ? "opacity-100"
            : "opacity-0 group-hover:opacity-100"
        }
      `}
    >
      {isPlaying ? (
        <Pause size={18} strokeWidth={2.5} />
      ) : (
        <Play size={18} strokeWidth={2.5} fill="currentColor" />
      )}
    </button>
  )
}

export default memo(PlaylistCardPlayButton)
   */